
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/criticas",
      function () {
        return require("private-next-pages/[region]/[resort]/criticas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/criticas"])
      });
    }
  